import { defineMessages, type MessageDescriptor } from 'react-intl';

// Keys are registration API values; only the displayed labels are translated.
export const webinarCountryMessages: Record<string, MessageDescriptor> = defineMessages({
	Afghanistan: {
		id: 'uniform.webinarForm.country.Afghanistan',
		defaultMessage: 'Afghanistan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Albania: {
		id: 'uniform.webinarForm.country.Albania',
		defaultMessage: 'Albania',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Algeria: {
		id: 'uniform.webinarForm.country.Algeria',
		defaultMessage: 'Algeria',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'American Samoa': {
		id: 'uniform.webinarForm.country.AmericanSamoa',
		defaultMessage: 'American Samoa',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Andorra: {
		id: 'uniform.webinarForm.country.Andorra',
		defaultMessage: 'Andorra',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Angola: {
		id: 'uniform.webinarForm.country.Angola',
		defaultMessage: 'Angola',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Anguilla: {
		id: 'uniform.webinarForm.country.Anguilla',
		defaultMessage: 'Anguilla',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Antarctica: {
		id: 'uniform.webinarForm.country.Antarctica',
		defaultMessage: 'Antarctica',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Antigua and Barbuda': {
		id: 'uniform.webinarForm.country.AntiguaandBarbuda',
		defaultMessage: 'Antigua and Barbuda',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Argentina: {
		id: 'uniform.webinarForm.country.Argentina',
		defaultMessage: 'Argentina',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Armenia: {
		id: 'uniform.webinarForm.country.Armenia',
		defaultMessage: 'Armenia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Aruba: {
		id: 'uniform.webinarForm.country.Aruba',
		defaultMessage: 'Aruba',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Australia: {
		id: 'uniform.webinarForm.country.Australia',
		defaultMessage: 'Australia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Austria: {
		id: 'uniform.webinarForm.country.Austria',
		defaultMessage: 'Austria',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Azerbaijan: {
		id: 'uniform.webinarForm.country.Azerbaijan',
		defaultMessage: 'Azerbaijan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Bahamas: {
		id: 'uniform.webinarForm.country.Bahamas',
		defaultMessage: 'Bahamas',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Bahrain: {
		id: 'uniform.webinarForm.country.Bahrain',
		defaultMessage: 'Bahrain',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Bangladesh: {
		id: 'uniform.webinarForm.country.Bangladesh',
		defaultMessage: 'Bangladesh',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Barbados: {
		id: 'uniform.webinarForm.country.Barbados',
		defaultMessage: 'Barbados',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Belarus: {
		id: 'uniform.webinarForm.country.Belarus',
		defaultMessage: 'Belarus',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Belgium: {
		id: 'uniform.webinarForm.country.Belgium',
		defaultMessage: 'Belgium',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Belize: {
		id: 'uniform.webinarForm.country.Belize',
		defaultMessage: 'Belize',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Benin: {
		id: 'uniform.webinarForm.country.Benin',
		defaultMessage: 'Benin',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Bermuda: {
		id: 'uniform.webinarForm.country.Bermuda',
		defaultMessage: 'Bermuda',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Bhutan: {
		id: 'uniform.webinarForm.country.Bhutan',
		defaultMessage: 'Bhutan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Bolivia: {
		id: 'uniform.webinarForm.country.Bolivia',
		defaultMessage: 'Bolivia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Bosnia and Herzegovina': {
		id: 'uniform.webinarForm.country.BosniaandHerzegovina',
		defaultMessage: 'Bosnia and Herzegovina',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Botswana: {
		id: 'uniform.webinarForm.country.Botswana',
		defaultMessage: 'Botswana',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Bouvet Island': {
		id: 'uniform.webinarForm.country.BouvetIsland',
		defaultMessage: 'Bouvet Island',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Brazil: {
		id: 'uniform.webinarForm.country.Brazil',
		defaultMessage: 'Brazil',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'British Indian Ocean Territory': {
		id: 'uniform.webinarForm.country.BritishIndianOceanTerritory',
		defaultMessage: 'British Indian Ocean Territory',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Brunei: {
		id: 'uniform.webinarForm.country.Brunei',
		defaultMessage: 'Brunei',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Bulgaria: {
		id: 'uniform.webinarForm.country.Bulgaria',
		defaultMessage: 'Bulgaria',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Burkina Faso': {
		id: 'uniform.webinarForm.country.BurkinaFaso',
		defaultMessage: 'Burkina Faso',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Burundi: {
		id: 'uniform.webinarForm.country.Burundi',
		defaultMessage: 'Burundi',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Cambodia: {
		id: 'uniform.webinarForm.country.Cambodia',
		defaultMessage: 'Cambodia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Cameroon: {
		id: 'uniform.webinarForm.country.Cameroon',
		defaultMessage: 'Cameroon',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Canada: {
		id: 'uniform.webinarForm.country.Canada',
		defaultMessage: 'Canada',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Cape Verde': {
		id: 'uniform.webinarForm.country.CapeVerde',
		defaultMessage: 'Cape Verde',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Cayman Islands': {
		id: 'uniform.webinarForm.country.CaymanIslands',
		defaultMessage: 'Cayman Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Central African Republic': {
		id: 'uniform.webinarForm.country.CentralAfricanRepublic',
		defaultMessage: 'Central African Republic',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Chad: {
		id: 'uniform.webinarForm.country.Chad',
		defaultMessage: 'Chad',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Chile: {
		id: 'uniform.webinarForm.country.Chile',
		defaultMessage: 'Chile',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	China: {
		id: 'uniform.webinarForm.country.China',
		defaultMessage: 'China',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Christmas Island': {
		id: 'uniform.webinarForm.country.ChristmasIsland',
		defaultMessage: 'Christmas Island',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Cocos Keeling Islands': {
		id: 'uniform.webinarForm.country.CocosKeelingIslands',
		defaultMessage: 'Cocos Keeling Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Colombia: {
		id: 'uniform.webinarForm.country.Colombia',
		defaultMessage: 'Colombia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Comoros: {
		id: 'uniform.webinarForm.country.Comoros',
		defaultMessage: 'Comoros',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Congo Democratic Peoples Republic': {
		id: 'uniform.webinarForm.country.CongoDemocraticPeoplesRepublic',
		defaultMessage: 'Congo Democratic Peoples Republic',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Congo Republic of': {
		id: 'uniform.webinarForm.country.CongoRepublicof',
		defaultMessage: 'Congo Republic of',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Cook Islands': {
		id: 'uniform.webinarForm.country.CookIslands',
		defaultMessage: 'Cook Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Costa Rica': {
		id: 'uniform.webinarForm.country.CostaRica',
		defaultMessage: 'Costa Rica',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Cote dIvoire Ivory Coast': {
		id: 'uniform.webinarForm.country.CotedIvoireIvoryCoast',
		defaultMessage: 'Cote dIvoire Ivory Coast',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Croatia Hrvatska': {
		id: 'uniform.webinarForm.country.CroatiaHrvatska',
		defaultMessage: 'Croatia Hrvatska',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Cuba: {
		id: 'uniform.webinarForm.country.Cuba',
		defaultMessage: 'Cuba',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Cyprus: {
		id: 'uniform.webinarForm.country.Cyprus',
		defaultMessage: 'Cyprus',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Czech Republic': {
		id: 'uniform.webinarForm.country.CzechRepublic',
		defaultMessage: 'Czech Republic',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Denmark: {
		id: 'uniform.webinarForm.country.Denmark',
		defaultMessage: 'Denmark',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Djibouti: {
		id: 'uniform.webinarForm.country.Djibouti',
		defaultMessage: 'Djibouti',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Dominica: {
		id: 'uniform.webinarForm.country.Dominica',
		defaultMessage: 'Dominica',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Dominican Republic': {
		id: 'uniform.webinarForm.country.DominicanRepublic',
		defaultMessage: 'Dominican Republic',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Ecuador: {
		id: 'uniform.webinarForm.country.Ecuador',
		defaultMessage: 'Ecuador',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Egypt: {
		id: 'uniform.webinarForm.country.Egypt',
		defaultMessage: 'Egypt',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'El Salvador': {
		id: 'uniform.webinarForm.country.ElSalvador',
		defaultMessage: 'El Salvador',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Equatorial Guinea': {
		id: 'uniform.webinarForm.country.EquatorialGuinea',
		defaultMessage: 'Equatorial Guinea',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Eritrea: {
		id: 'uniform.webinarForm.country.Eritrea',
		defaultMessage: 'Eritrea',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Estonia: {
		id: 'uniform.webinarForm.country.Estonia',
		defaultMessage: 'Estonia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Ethiopia: {
		id: 'uniform.webinarForm.country.Ethiopia',
		defaultMessage: 'Ethiopia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Falkland Islands': {
		id: 'uniform.webinarForm.country.FalklandIslands',
		defaultMessage: 'Falkland Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Faroe Islands': {
		id: 'uniform.webinarForm.country.FaroeIslands',
		defaultMessage: 'Faroe Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Fiji: {
		id: 'uniform.webinarForm.country.Fiji',
		defaultMessage: 'Fiji',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Finland: {
		id: 'uniform.webinarForm.country.Finland',
		defaultMessage: 'Finland',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	France: {
		id: 'uniform.webinarForm.country.France',
		defaultMessage: 'France',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'French Guiana': {
		id: 'uniform.webinarForm.country.FrenchGuiana',
		defaultMessage: 'French Guiana',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'French Polynesia': {
		id: 'uniform.webinarForm.country.FrenchPolynesia',
		defaultMessage: 'French Polynesia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'French Southern Territories': {
		id: 'uniform.webinarForm.country.FrenchSouthernTerritories',
		defaultMessage: 'French Southern Territories',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Gabon: {
		id: 'uniform.webinarForm.country.Gabon',
		defaultMessage: 'Gabon',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Gambia: {
		id: 'uniform.webinarForm.country.Gambia',
		defaultMessage: 'Gambia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Georgia: {
		id: 'uniform.webinarForm.country.Georgia',
		defaultMessage: 'Georgia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Germany: {
		id: 'uniform.webinarForm.country.Germany',
		defaultMessage: 'Germany',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Ghana: {
		id: 'uniform.webinarForm.country.Ghana',
		defaultMessage: 'Ghana',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Gibraltar: {
		id: 'uniform.webinarForm.country.Gibraltar',
		defaultMessage: 'Gibraltar',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Greece: {
		id: 'uniform.webinarForm.country.Greece',
		defaultMessage: 'Greece',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Greenland: {
		id: 'uniform.webinarForm.country.Greenland',
		defaultMessage: 'Greenland',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Grenada: {
		id: 'uniform.webinarForm.country.Grenada',
		defaultMessage: 'Grenada',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Guadeloupe: {
		id: 'uniform.webinarForm.country.Guadeloupe',
		defaultMessage: 'Guadeloupe',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Guam: {
		id: 'uniform.webinarForm.country.Guam',
		defaultMessage: 'Guam',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Guatemala: {
		id: 'uniform.webinarForm.country.Guatemala',
		defaultMessage: 'Guatemala',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Guernsey: {
		id: 'uniform.webinarForm.country.Guernsey',
		defaultMessage: 'Guernsey',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Guinea: {
		id: 'uniform.webinarForm.country.Guinea',
		defaultMessage: 'Guinea',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Guinea-Bissau': {
		id: 'uniform.webinarForm.country.GuineaBissau',
		defaultMessage: 'Guinea-Bissau',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Guyana: {
		id: 'uniform.webinarForm.country.Guyana',
		defaultMessage: 'Guyana',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Haiti: {
		id: 'uniform.webinarForm.country.Haiti',
		defaultMessage: 'Haiti',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Heard and McDonald Islands': {
		id: 'uniform.webinarForm.country.HeardandMcDonaldIslands',
		defaultMessage: 'Heard and McDonald Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Honduras: {
		id: 'uniform.webinarForm.country.Honduras',
		defaultMessage: 'Honduras',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Hong Kong': {
		id: 'uniform.webinarForm.country.HongKong',
		defaultMessage: 'Hong Kong',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Hungary: {
		id: 'uniform.webinarForm.country.Hungary',
		defaultMessage: 'Hungary',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Iceland: {
		id: 'uniform.webinarForm.country.Iceland',
		defaultMessage: 'Iceland',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	India: {
		id: 'uniform.webinarForm.country.India',
		defaultMessage: 'India',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Indonesia: {
		id: 'uniform.webinarForm.country.Indonesia',
		defaultMessage: 'Indonesia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Iran: {
		id: 'uniform.webinarForm.country.Iran',
		defaultMessage: 'Iran',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Iraq: {
		id: 'uniform.webinarForm.country.Iraq',
		defaultMessage: 'Iraq',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Ireland: {
		id: 'uniform.webinarForm.country.Ireland',
		defaultMessage: 'Ireland',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Isle of Man': {
		id: 'uniform.webinarForm.country.IsleofMan',
		defaultMessage: 'Isle of Man',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Israel: {
		id: 'uniform.webinarForm.country.Israel',
		defaultMessage: 'Israel',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Italy: {
		id: 'uniform.webinarForm.country.Italy',
		defaultMessage: 'Italy',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Jamaica: {
		id: 'uniform.webinarForm.country.Jamaica',
		defaultMessage: 'Jamaica',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Japan: {
		id: 'uniform.webinarForm.country.Japan',
		defaultMessage: 'Japan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Jersey: {
		id: 'uniform.webinarForm.country.Jersey',
		defaultMessage: 'Jersey',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Jordan: {
		id: 'uniform.webinarForm.country.Jordan',
		defaultMessage: 'Jordan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Kazakhstan: {
		id: 'uniform.webinarForm.country.Kazakhstan',
		defaultMessage: 'Kazakhstan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Kenya: {
		id: 'uniform.webinarForm.country.Kenya',
		defaultMessage: 'Kenya',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Kiribati: {
		id: 'uniform.webinarForm.country.Kiribati',
		defaultMessage: 'Kiribati',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Korea North': {
		id: 'uniform.webinarForm.country.KoreaNorth',
		defaultMessage: 'Korea North',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Korea South': {
		id: 'uniform.webinarForm.country.KoreaSouth',
		defaultMessage: 'Korea South',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Kuwait: {
		id: 'uniform.webinarForm.country.Kuwait',
		defaultMessage: 'Kuwait',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Kyrgyzstan: {
		id: 'uniform.webinarForm.country.Kyrgyzstan',
		defaultMessage: 'Kyrgyzstan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Laos: {
		id: 'uniform.webinarForm.country.Laos',
		defaultMessage: 'Laos',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Latvia: {
		id: 'uniform.webinarForm.country.Latvia',
		defaultMessage: 'Latvia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Lebanon: {
		id: 'uniform.webinarForm.country.Lebanon',
		defaultMessage: 'Lebanon',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Lesotho: {
		id: 'uniform.webinarForm.country.Lesotho',
		defaultMessage: 'Lesotho',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Liberia: {
		id: 'uniform.webinarForm.country.Liberia',
		defaultMessage: 'Liberia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Libya: {
		id: 'uniform.webinarForm.country.Libya',
		defaultMessage: 'Libya',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Liechtenstein: {
		id: 'uniform.webinarForm.country.Liechtenstein',
		defaultMessage: 'Liechtenstein',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Lithuania: {
		id: 'uniform.webinarForm.country.Lithuania',
		defaultMessage: 'Lithuania',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Luxembourg: {
		id: 'uniform.webinarForm.country.Luxembourg',
		defaultMessage: 'Luxembourg',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Macau: {
		id: 'uniform.webinarForm.country.Macau',
		defaultMessage: 'Macau',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Macedonia: {
		id: 'uniform.webinarForm.country.Macedonia',
		defaultMessage: 'Macedonia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Madagascar: {
		id: 'uniform.webinarForm.country.Madagascar',
		defaultMessage: 'Madagascar',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Malawi: {
		id: 'uniform.webinarForm.country.Malawi',
		defaultMessage: 'Malawi',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Malaysia: {
		id: 'uniform.webinarForm.country.Malaysia',
		defaultMessage: 'Malaysia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Maldives: {
		id: 'uniform.webinarForm.country.Maldives',
		defaultMessage: 'Maldives',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Mali: {
		id: 'uniform.webinarForm.country.Mali',
		defaultMessage: 'Mali',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Malta: {
		id: 'uniform.webinarForm.country.Malta',
		defaultMessage: 'Malta',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Marshall Islands': {
		id: 'uniform.webinarForm.country.MarshallIslands',
		defaultMessage: 'Marshall Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Martinique: {
		id: 'uniform.webinarForm.country.Martinique',
		defaultMessage: 'Martinique',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Mauritania: {
		id: 'uniform.webinarForm.country.Mauritania',
		defaultMessage: 'Mauritania',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Mauritius: {
		id: 'uniform.webinarForm.country.Mauritius',
		defaultMessage: 'Mauritius',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Mayotte: {
		id: 'uniform.webinarForm.country.Mayotte',
		defaultMessage: 'Mayotte',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Mexico: {
		id: 'uniform.webinarForm.country.Mexico',
		defaultMessage: 'Mexico',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Micronesia: {
		id: 'uniform.webinarForm.country.Micronesia',
		defaultMessage: 'Micronesia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Moldova: {
		id: 'uniform.webinarForm.country.Moldova',
		defaultMessage: 'Moldova',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Monaco: {
		id: 'uniform.webinarForm.country.Monaco',
		defaultMessage: 'Monaco',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Mongolia: {
		id: 'uniform.webinarForm.country.Mongolia',
		defaultMessage: 'Mongolia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Montenegro: {
		id: 'uniform.webinarForm.country.Montenegro',
		defaultMessage: 'Montenegro',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Montserrat: {
		id: 'uniform.webinarForm.country.Montserrat',
		defaultMessage: 'Montserrat',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Morocco: {
		id: 'uniform.webinarForm.country.Morocco',
		defaultMessage: 'Morocco',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Mozambique: {
		id: 'uniform.webinarForm.country.Mozambique',
		defaultMessage: 'Mozambique',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Myanmar: {
		id: 'uniform.webinarForm.country.Myanmar',
		defaultMessage: 'Myanmar',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Namibia: {
		id: 'uniform.webinarForm.country.Namibia',
		defaultMessage: 'Namibia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Nauru: {
		id: 'uniform.webinarForm.country.Nauru',
		defaultMessage: 'Nauru',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Nepal: {
		id: 'uniform.webinarForm.country.Nepal',
		defaultMessage: 'Nepal',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Netherlands: {
		id: 'uniform.webinarForm.country.Netherlands',
		defaultMessage: 'Netherlands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Netherlands Antilles': {
		id: 'uniform.webinarForm.country.NetherlandsAntilles',
		defaultMessage: 'Netherlands Antilles',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'New Caledonia': {
		id: 'uniform.webinarForm.country.NewCaledonia',
		defaultMessage: 'New Caledonia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'New Zealand': {
		id: 'uniform.webinarForm.country.NewZealand',
		defaultMessage: 'New Zealand',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Nicaragua: {
		id: 'uniform.webinarForm.country.Nicaragua',
		defaultMessage: 'Nicaragua',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Niger: {
		id: 'uniform.webinarForm.country.Niger',
		defaultMessage: 'Niger',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Nigeria: {
		id: 'uniform.webinarForm.country.Nigeria',
		defaultMessage: 'Nigeria',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Niue: {
		id: 'uniform.webinarForm.country.Niue',
		defaultMessage: 'Niue',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Norfolk Island': {
		id: 'uniform.webinarForm.country.NorfolkIsland',
		defaultMessage: 'Norfolk Island',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Northern Mariana Islands': {
		id: 'uniform.webinarForm.country.NorthernMarianaIslands',
		defaultMessage: 'Northern Mariana Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Norway: {
		id: 'uniform.webinarForm.country.Norway',
		defaultMessage: 'Norway',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Oman: {
		id: 'uniform.webinarForm.country.Oman',
		defaultMessage: 'Oman',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Pakistan: {
		id: 'uniform.webinarForm.country.Pakistan',
		defaultMessage: 'Pakistan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Palau: {
		id: 'uniform.webinarForm.country.Palau',
		defaultMessage: 'Palau',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Palestinian Territories': {
		id: 'uniform.webinarForm.country.PalestinianTerritories',
		defaultMessage: 'Palestinian Territories',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Panama: {
		id: 'uniform.webinarForm.country.Panama',
		defaultMessage: 'Panama',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Papua New Guinea': {
		id: 'uniform.webinarForm.country.PapuaNewGuinea',
		defaultMessage: 'Papua New Guinea',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Paraguay: {
		id: 'uniform.webinarForm.country.Paraguay',
		defaultMessage: 'Paraguay',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Peru: {
		id: 'uniform.webinarForm.country.Peru',
		defaultMessage: 'Peru',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Philippines: {
		id: 'uniform.webinarForm.country.Philippines',
		defaultMessage: 'Philippines',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Pitcairn: {
		id: 'uniform.webinarForm.country.Pitcairn',
		defaultMessage: 'Pitcairn',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Poland: {
		id: 'uniform.webinarForm.country.Poland',
		defaultMessage: 'Poland',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Portugal: {
		id: 'uniform.webinarForm.country.Portugal',
		defaultMessage: 'Portugal',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Puerto Rico': {
		id: 'uniform.webinarForm.country.PuertoRico',
		defaultMessage: 'Puerto Rico',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Qatar: {
		id: 'uniform.webinarForm.country.Qatar',
		defaultMessage: 'Qatar',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Reunion: {
		id: 'uniform.webinarForm.country.Reunion',
		defaultMessage: 'Reunion',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Romania: {
		id: 'uniform.webinarForm.country.Romania',
		defaultMessage: 'Romania',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Russian Federation': {
		id: 'uniform.webinarForm.country.RussianFederation',
		defaultMessage: 'Russian Federation',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Rwanda: {
		id: 'uniform.webinarForm.country.Rwanda',
		defaultMessage: 'Rwanda',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Saint Helena': {
		id: 'uniform.webinarForm.country.SaintHelena',
		defaultMessage: 'Saint Helena',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Saint Kitts and Nevis': {
		id: 'uniform.webinarForm.country.SaintKittsandNevis',
		defaultMessage: 'Saint Kitts and Nevis',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Saint Lucia': {
		id: 'uniform.webinarForm.country.SaintLucia',
		defaultMessage: 'Saint Lucia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Saint Pierre and Miquelon': {
		id: 'uniform.webinarForm.country.SaintPierreandMiquelon',
		defaultMessage: 'Saint Pierre and Miquelon',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Saint Vincent and the Grenadines': {
		id: 'uniform.webinarForm.country.SaintVincentandtheGrenadines',
		defaultMessage: 'Saint Vincent and the Grenadines',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Samoa: {
		id: 'uniform.webinarForm.country.Samoa',
		defaultMessage: 'Samoa',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'San Marino': {
		id: 'uniform.webinarForm.country.SanMarino',
		defaultMessage: 'San Marino',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Sao Tome and Principe': {
		id: 'uniform.webinarForm.country.SaoTomeandPrincipe',
		defaultMessage: 'Sao Tome and Principe',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Saudi Arabia': {
		id: 'uniform.webinarForm.country.SaudiArabia',
		defaultMessage: 'Saudi Arabia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Senegal: {
		id: 'uniform.webinarForm.country.Senegal',
		defaultMessage: 'Senegal',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Serbia: {
		id: 'uniform.webinarForm.country.Serbia',
		defaultMessage: 'Serbia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Serbia and Montenegro': {
		id: 'uniform.webinarForm.country.SerbiaandMontenegro',
		defaultMessage: 'Serbia and Montenegro',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Seychelles: {
		id: 'uniform.webinarForm.country.Seychelles',
		defaultMessage: 'Seychelles',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Sierra Leone': {
		id: 'uniform.webinarForm.country.SierraLeone',
		defaultMessage: 'Sierra Leone',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Singapore: {
		id: 'uniform.webinarForm.country.Singapore',
		defaultMessage: 'Singapore',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Slovak Republic': {
		id: 'uniform.webinarForm.country.SlovakRepublic',
		defaultMessage: 'Slovak Republic',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Slovenia: {
		id: 'uniform.webinarForm.country.Slovenia',
		defaultMessage: 'Slovenia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Solomon Islands': {
		id: 'uniform.webinarForm.country.SolomonIslands',
		defaultMessage: 'Solomon Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Somalia: {
		id: 'uniform.webinarForm.country.Somalia',
		defaultMessage: 'Somalia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'South Africa': {
		id: 'uniform.webinarForm.country.SouthAfrica',
		defaultMessage: 'South Africa',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'South Georgia and the South Sandwich Islands': {
		id: 'uniform.webinarForm.country.SouthGeorgiaandtheSouthSandwichIslands',
		defaultMessage: 'South Georgia and the South Sandwich Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Spain: {
		id: 'uniform.webinarForm.country.Spain',
		defaultMessage: 'Spain',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Sri Lanka': {
		id: 'uniform.webinarForm.country.SriLanka',
		defaultMessage: 'Sri Lanka',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Sudan: {
		id: 'uniform.webinarForm.country.Sudan',
		defaultMessage: 'Sudan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Suriname: {
		id: 'uniform.webinarForm.country.Suriname',
		defaultMessage: 'Suriname',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Svalbard and Jan Mayen Islands': {
		id: 'uniform.webinarForm.country.SvalbardandJanMayenIslands',
		defaultMessage: 'Svalbard and Jan Mayen Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Swaziland: {
		id: 'uniform.webinarForm.country.Swaziland',
		defaultMessage: 'Swaziland',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Sweden: {
		id: 'uniform.webinarForm.country.Sweden',
		defaultMessage: 'Sweden',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Switzerland: {
		id: 'uniform.webinarForm.country.Switzerland',
		defaultMessage: 'Switzerland',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Syria: {
		id: 'uniform.webinarForm.country.Syria',
		defaultMessage: 'Syria',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Taiwan: {
		id: 'uniform.webinarForm.country.Taiwan',
		defaultMessage: 'Taiwan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Tajikistan: {
		id: 'uniform.webinarForm.country.Tajikistan',
		defaultMessage: 'Tajikistan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Tanzania: {
		id: 'uniform.webinarForm.country.Tanzania',
		defaultMessage: 'Tanzania',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Thailand: {
		id: 'uniform.webinarForm.country.Thailand',
		defaultMessage: 'Thailand',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Timor-Leste': {
		id: 'uniform.webinarForm.country.TimorLeste',
		defaultMessage: 'Timor-Leste',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Togo: {
		id: 'uniform.webinarForm.country.Togo',
		defaultMessage: 'Togo',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Tokelau: {
		id: 'uniform.webinarForm.country.Tokelau',
		defaultMessage: 'Tokelau',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Tonga: {
		id: 'uniform.webinarForm.country.Tonga',
		defaultMessage: 'Tonga',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Trinidad and Tobago': {
		id: 'uniform.webinarForm.country.TrinidadandTobago',
		defaultMessage: 'Trinidad and Tobago',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Tunisia: {
		id: 'uniform.webinarForm.country.Tunisia',
		defaultMessage: 'Tunisia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Turkey: {
		id: 'uniform.webinarForm.country.Turkey',
		defaultMessage: 'Turkey',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Turkmenistan: {
		id: 'uniform.webinarForm.country.Turkmenistan',
		defaultMessage: 'Turkmenistan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Turks and Caicos Islands': {
		id: 'uniform.webinarForm.country.TurksandCaicosIslands',
		defaultMessage: 'Turks and Caicos Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Tuvalu: {
		id: 'uniform.webinarForm.country.Tuvalu',
		defaultMessage: 'Tuvalu',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Uganda: {
		id: 'uniform.webinarForm.country.Uganda',
		defaultMessage: 'Uganda',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Ukraine: {
		id: 'uniform.webinarForm.country.Ukraine',
		defaultMessage: 'Ukraine',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'United Arab Emirates': {
		id: 'uniform.webinarForm.country.UnitedArabEmirates',
		defaultMessage: 'United Arab Emirates',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'United Kingdom': {
		id: 'uniform.webinarForm.country.UnitedKingdom',
		defaultMessage: 'United Kingdom',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'United States of America': {
		id: 'uniform.webinarForm.country.UnitedStatesofAmerica',
		defaultMessage: 'United States of America',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Uruguay: {
		id: 'uniform.webinarForm.country.Uruguay',
		defaultMessage: 'Uruguay',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Uzbekistan: {
		id: 'uniform.webinarForm.country.Uzbekistan',
		defaultMessage: 'Uzbekistan',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Vanuatu: {
		id: 'uniform.webinarForm.country.Vanuatu',
		defaultMessage: 'Vanuatu',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Vatican City': {
		id: 'uniform.webinarForm.country.VaticanCity',
		defaultMessage: 'Vatican City',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Venezuela: {
		id: 'uniform.webinarForm.country.Venezuela',
		defaultMessage: 'Venezuela',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Vietnam: {
		id: 'uniform.webinarForm.country.Vietnam',
		defaultMessage: 'Vietnam',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Virgin Islands British': {
		id: 'uniform.webinarForm.country.VirginIslandsBritish',
		defaultMessage: 'Virgin Islands British',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Virgin Islands US': {
		id: 'uniform.webinarForm.country.VirginIslandsUS',
		defaultMessage: 'Virgin Islands US',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Wallis and Futuna Islands': {
		id: 'uniform.webinarForm.country.WallisandFutunaIslands',
		defaultMessage: 'Wallis and Futuna Islands',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	'Western Sahara': {
		id: 'uniform.webinarForm.country.WesternSahara',
		defaultMessage: 'Western Sahara',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Yemen: {
		id: 'uniform.webinarForm.country.Yemen',
		defaultMessage: 'Yemen',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Zambia: {
		id: 'uniform.webinarForm.country.Zambia',
		defaultMessage: 'Zambia',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
	Zimbabwe: {
		id: 'uniform.webinarForm.country.Zimbabwe',
		defaultMessage: 'Zimbabwe',
		description: 'Country or territory label in the webinar registration country dropdown.',
	},
});
